<template>
  <div
    @mouseenter="showDropdown()"
    @mouseleave="hideDropdown()"
    @click="hideMenuInMobile()"
  >
    <router-link
      :to="link"
      class="navbar-item"
      :class="{'router-link-active': title === 'AHL Services' && this.$route.path === '/services/join' || title === 'AHL Services' && this.$route.path === '/services/fee'}"
      exact
    >
      <span>{{ title }}</span>
      <span
        v-if="dropdown"
        class="icon is-small"
      >
        <i
          class="far fa-angle-down"
          aria-hidden="true"
        />
      </span>
      <div
        v-if="active && dropdown"
        id="dropdown-menu"
        class="dropdown-menu is-block is-shadowless"
        role="menu"
      >
        <div class="dropdown-content">
          <router-link
            v-for="item in dropdown"
            :key="item.id"
            :to="item.link"
            class="dropdown-item"
          >
            {{ item.title }}
          </router-link>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'MenuTab',
    props: ['title', 'link', 'dropdown'],
    data () {
      return {
        active: false
      }
    },
    mounted () {
      if (window.innerWidth < 1024) {
        this.active = true
      }
    },
    methods: {
      showDropdown () {
        if (this.dropdown) {
          this.active = true
        }
      },
      hideDropdown () {
        if (this.dropdown && window.innerWidth > 1023) {
          this.active = false
        }
      },
      hideMenuInMobile () {
        this.$emit('hideMenuInMobile')
      }
    }
  }
</script>
